function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExpensifyCardIcon = function SvgExpensifyCardIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1.8 4C.8 4 0 4.8 0 5.8v9.5c0 1 .8 1.8 1.8 1.8h16.5c1 0 1.8-.8 1.8-1.8V5.8c0-1-.8-1.8-1.8-1.8H1.8zM13 15H7V6h6v2H9v1.5h3v1.9H9V13h4v2z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgExpensifyCardIcon;